export default __webpack_public_path__ + "static/media/dropdown-arrow.385c3232.svg";